import { Dispatch, SetStateAction, useCallback } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from "@fortawesome/pro-solid-svg-icons"
import { makeStyles } from "tss-react/mui"
import { Grid } from "@mui/material"
import { DialogStateProps } from "./CreateUpdateSurveyFormContent"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { StandardButton } from "../../../../../shared/components/buttons/StandardButton"

const useStyles = makeStyles()((theme) => ({
    addButton: {
        background: "#2196F3",
    },
}))

type AddQuestionButtonProps = Readonly<{
    setDialogState: Dispatch<SetStateAction<DialogStateProps>>
}>

export const AddQuestionButton = ({ setDialogState }: AddQuestionButtonProps) => {
    const { classes } = useStyles()
    const handleAddClick = useCallback(() => {
        setDialogState((prev) => ({ ...prev, show: !prev.show }))
    }, [setDialogState])
    return (
        <Grid>
            <LocalizedStrict id="create-or-edit-merchant-survey-add-questions-button">
                <StandardButton
                    onClick={handleAddClick}
                    fullWidth={false}
                    color="primary"
                    startIcon={<FontAwesomeIcon icon={faPlus} />}
                    className={classes.addButton}
                >
                    Add question
                </StandardButton>
            </LocalizedStrict>
        </Grid>
    )
}
